const ITEMS = [
  "GO LIVE TOGETHER",
  "EVERY MOMENT IS A PORTAL",
  "TAP TO ENTER",
  "BE THERE. TOGETHER.",
  "GOTHENBURG — WORLDWIDE",
  "IN-ITAPP.COM",
];

export const EditorialMarquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative border-y border-white/10 bg-black/40 backdrop-blur-md py-5 overflow-hidden">
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-400 px-8">{item}</span>
            <span className="text-ink-coral text-xs">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
